import {Modal} from 'react-bootstrap'
import styles from './EmployeeDeleteModal.css'

const EmployeeDeleteModal = ({show, onCancel, onDelete, employee}) => {
  return <Modal show={show} onHide={() => {}} dialogClassName={`modal-dialog ${styles.dialog}`}>
    <Modal.Header bsClass={`modal-header ${styles.header}`}>
      <Modal.Title className={styles.title}>Delete Employee</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <b>{employee.first_name} {employee.last_name}</b> has been associated with role <b className={styles.role}>{employee.role.name}</b> in {employee.outlets.length} Outlets. Are you sure want to remove this employee?
    </Modal.Body>
    <Modal.Footer>
      <span className='pull-right'>
        <button onClick={onCancel} className='btn btn-default'>Cancel</button>
        <button onClick={onDelete} className='btn btn-danger'>Delete</button>
      </span>
    </Modal.Footer>
  </Modal>
}

export default EmployeeDeleteModal



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffDetail/EmployeeDeleteModal/EmployeeDeleteModal.js